import React, {Component, Fragment} from "react";
import {Button, ButtonGroup, ButtonToolbar, Col, Grid, Row, Table} from "react-bootstrap";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

import AddTranslationKeyModal from "./AddTranslationKeyModal";
import EditableText from "./EditableText";
import SearchBar from "./SearchBar";

import { authorised } from '../layout/authorised';

import {getLanguages, saveTranslationKeys} from "../../redux/actions";
import Link from "react-router-dom/es/Link";

class LanguageDynamicEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visibleLanguageIds: [],
            saving: false,
            master: null,
            bases: [],
            customerLanguages: [],
            query: "",
            adding: null
        };
    }

    componentDidMount() {
        if(this.props.languages) {
            this.determineLanguages()
        }
        else {
            this.props.dispatch(getLanguages());
        }
    }

    componentDidUpdate(prevProps) {
        if (this.state.saving && this.props.pendingCalls === 0) {
            this.setState({saving: false, showModal: false});
            this.props.dispatch(getLanguages());
            console.info("Reloading languages...")
        }

        if (this.props.languages !== prevProps.languages) {
            this.determineLanguages();
        }
    }

    determineLanguages() {
        this.setState({
            master: this.props.languages.find(l => l.master === true),
            bases: this.props.languages.filter(l => l.base === true && l.master === false),
            customerLanguages: this.props.languages.filter(l => l.base === false && l.master === false && l.customerId),
        })
    }

    toggleLanguage(language) {
        // copy state to locally scoped RAM memory to still be immutable, even if push is used.
        // Keeping Mutable state local :)
        let immutableCopy = [...this.state.visibleLanguageIds];

        if (typeof immutableCopy.filter(langId => langId === language.id)[0] !== "undefined") { // if exists
            immutableCopy = immutableCopy.filter(langId => langId !== language.id)   // remove
        }
        else {
            immutableCopy.push(language.id);       // else add
        }

        this.setState({
            visibleLanguageIds: this.sortLanguages(immutableCopy)
        })
    }

    /**
     * Sorting for languages, master is always on top, followed by bases, and customer languages are at the bottom.
     */
    sortLanguages(languages) {
        return languages.sort((a, b) => {
            if (a.master && !b.master) {
                return -1;
            }
            else if (!a.master && b.master) {
                return 1
            }
            else if (a.base && !b.base) {
                return -1
            }
            else if (!a.base && b.base) {
                return 1
            }
            else
                return 0
        })
    }

    languageIsActive(languageId) {
        return typeof this.state.visibleLanguageIds.find(langId => langId === languageId) !== "undefined"
    }

    language(languageId) {
        return languageId ? this.props.languages.find(language => language.id === languageId) : null;
    }

    customer(customerId) {
        return customerId ? this.props.customers.find(customer => customer.id === customerId) : null;
    }

    languageName(language) {
        let name = language.languageCode;
        if (language.customerId) {
            let customer = this.customer(language.customerId);
            if (customer) {
                name = name + " - " + customer.name;
            }
        }

        return name;
    }

    limitValue(value, max) {
        if (value && value.substring) {
            if (value.length > max) {
                return "..." + value.substring(value.length - max, value.length)
            }
            else {
                return value;
            }
        }
        else {
            return value;
        }
    }

    visibleLanguages() {
        return this.state.visibleLanguageIds.map(id => this.language(id));
    }

    searchChanged(query) {
        this.setState({query})
    }

    sortedTranslationKeys(visibleLanguages) {
        const queryLower = this.state.query.toLowerCase();
        const matchesQuery = (translation) =>
            typeof translation === "string" && translation.toLowerCase().indexOf(queryLower) > -1;
        const keys = Object.keys(this.state.master.translations).filter(matchesQuery);
        for(const language of [this.state.master, ...visibleLanguages]) {
            Object.entries(language.translations).forEach(([key, translation]) => {
                if(matchesQuery(translation) && keys.indexOf(key) === -1)
                    keys.push(key);
            });
        }
        return keys.sort()
    }

    filterByLanguageCode(languages, visible) {
        if(visible.length === 0) {
            return languages.filter(language => {
                return language.languageCode === this.state.master.languageCode;
            });
        }
        else {
            return languages.filter(language => {
                return visible.filter(other => other.languageCode === language.languageCode).length > 0;
            });
        }
    }

    render() {
        if (!this.props.languages)
            return null;
        let visible = this.visibleLanguages();
        return (
            this.state.master && <Fragment>
                <Grid>
                    <h2>Translations</h2>
                    <p><Link to='/i18n'>View in table</Link></p>
                    <Row>
                        <Col xs={6} sm={6} md={6} lg={2}>
                            <label>Base languages</label>
                            <ButtonToolbar>
                                <ButtonGroup>
                                    {this.state.bases && this.sortLanguages(this.state.bases).map(lang =>
                                        <Button key={lang.id} active={this.languageIsActive(lang.id)}
                                                onClick={e => this.toggleLanguage(lang)}>{this.languageName(lang)}</Button>
                                    )}
                                </ButtonGroup>
                            </ButtonToolbar>
                        </Col>

                        <Col xs={6} sm={6} md={6} lg={10}>
                            <label>Customer languages</label>
                            <ButtonToolbar>
                                <ButtonGroup>
                                    {this.state.customerLanguages && this.sortLanguages(this.filterByLanguageCode(this.state.customerLanguages, visible)).map(lang =>
                                        <Button key={lang.id} active={this.languageIsActive(lang.id)}
                                                onClick={e => this.toggleLanguage(lang)}>{this.languageName(lang)}</Button>
                                    )}
                                </ButtonGroup>
                            </ButtonToolbar>
                        </Col>
                    </Row>

                    <Row style={{marginTop: "20px"}}>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <label>Search in visible keys</label>
                            <SearchBar onChange={query => this.searchChanged(query)}/>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <Table className="TranslationTable" striped bordered condensed hover>
                                <thead>
                                <tr>
                                    <th width="5%">
                                        I18N key

                                        <Button onClick={e => this.setState({ showModal: true })} id="add-translation-key">
                                            <i className="fas fa-plus"/>
                                        </Button>
                                    </th>
                                    <th width="30%">
                                        {this.languageName(this.state.master)}
                                    </th>
                                    {visible.map(language =>
                                        <th  width="30%" key={language.id}>{this.languageName(language)}</th>
                                    )}
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.query.length > 2
                                    ? this.sortedTranslationKeys(visible).map((translationKey) =>
                                        <tr key={translationKey}>
                                            <td width="5%">
                                                <div style={{maxWidth: "500px", overflowY: "scroll", height: "40px"}}>
                                                    {translationKey}
                                                </div>
                                            </td>
                                            {[this.state.master, ...visible].map(lang =>
                                                <EditableText
                                                    key={lang.id}
                                                    value={lang.translations[translationKey]}
                                                    onChange={value => this.updateTranslationKey(lang.id, translationKey, value)}
                                                />
                                            )}
                                        </tr>
                                    )
                                    : (
                                        <tr>
                                            <td colSpan={visible.length + 2}>Enter a search query of at least 3 characters...</td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Grid>
                <AddTranslationKeyModal
                    visible={this.state.showModal}
                    onSave={(data) => this.updateTranslationKey(this.state.master.id, data.key, data.value)}
                    onModalChange={(e) => this.setState({...this.state, showModal: e.visible})}
                />
            </Fragment>
        )
    }

    updateTranslationKey(langId, translationKey, value) {
        this.props.dispatch(saveTranslationKeys({id: langId, translationKeys: {[translationKey]: value}}));
        this.setState({saving: true})
    }
}

const mapStateToProps = state => {
    return {
        loggedIn: state.loggedIn,
        languages: state.languages,
        customers: state.customers,
        pendingCalls: state.pendingCalls
    };
};

const mapDispatchToProps = (dispatch) => ({dispatch});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(authorised(LanguageDynamicEditor)));



// WEBPACK FOOTER //
// ./src/components/languages/LanguageDynamicEditor.js